import React, { useRef } from 'react';
import debounce from 'debounce';

import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid'

const useStyles = makeStyles((theme) => ({
    paper: {
        marginTop: theme.spacing(2),
        display: 'flex',
        flexDirection: 'column',
        padding: '1rem'
    },
    field: {
        marginTop: theme.spacing(2),
    }
}));

const MemberProfile = ({ profile, onChange }) => {
    const classes = useStyles();
    const { title, summary, email, phoneNumber } = profile;
    const titleRef = useRef(title);
    const phoneRef = useRef(phoneNumber);
    const emailRef = useRef(email);
    const summaryRef = useRef(summary);

    const handleStateChange = debounce(fragment => {
        onChange(fragment);
    }, 500);

    if (!profile) return <></>

    return (
        <Paper className={classes.paper}>
            <Typography variant="h5">Your Intermediary CV</Typography>
            <Typography variant="subtitle2">This is what clients will see when they click on your profile link in the enquiry matching results</Typography>
            <Grid container spacing={1}>
                <Grid item xs={12} lg={6}>
                    <TextField onChange={() => handleStateChange({ title: titleRef.current.value })}
                        variant="outlined"
                        label="Your CV Title"
                        defaultValue={title}
                        inputRef={titleRef}
                        placeholder="eg Janet Smith, MSc., BSc., MRCSLT"
                        helperText="This is the headline displayed at the top of your CV"
                        style={{ width: '100%' }}
                        className={classes.field}
                    />
                </Grid>
                <Grid item xs={12} lg={3}>
                    <TextField onChange={() => handleStateChange({ phoneNumber: phoneRef.current.value })}
                        variant="outlined"
                        label="Your Contact Phone Number"
                        defaultValue={phoneNumber}
                        inputRef={phoneRef}
                        helperText="The number you want referrers to use"
                        style={{ width: '100%' }}
                        className={classes.field}
                    />
                </Grid>
                <Grid item xs={12} lg={3}>
                    <TextField onChange={() => handleStateChange({ email: emailRef.current.value })}
                        variant="outlined"
                        label="Your Contact Email Address"
                        defaultValue={email}
                        inputRef={emailRef}
                        helperText="The address you want referrers to use"
                        style={{ width: '100%' }}
                        className={classes.field}
                    />
                </Grid>
            </Grid>
            <TextField onChange={() => handleStateChange({ summary: summaryRef.current.value })}
                variant="outlined"
                label="Your profile"
                defaultValue={summary}
                inputRef={summaryRef}
                placeholder="A short summary of your relevant experience"
                fullWidth
                multiline
                helperText="Focus on what you think the person commissioning needs to know about you"
                rows={15}
                className={classes.field}
            />
        </Paper>
    );

};

export default MemberProfile;